import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Menubar from "./component/pages/Menubar";
import Home from "./component/pages/Home";
import About from "./component/pages/About";
import Product from "./component/pages/Product";
import Infrac from "./component/pages/Infrac";
import Contact from "./component/pages/Contact";
import Footer from "./component/pages/Footer";
import Loading from "./component/pages/Loading";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Menubar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/product" element={<Product />} />
        <Route path="/infrac" element={<Infrac />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
